import { render, staticRenderFns } from "./EditTalkgroup.vue?vue&type=template&id=ec26c342&scoped=true"
import script from "./EditTalkgroup.vue?vue&type=script&lang=js"
export * from "./EditTalkgroup.vue?vue&type=script&lang=js"
import style0 from "./EditTalkgroup.vue?vue&type=style&index=0&id=ec26c342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec26c342",
  null
  
)

export default component.exports